<template>
  <BI v-bind:id="1" :isHome="false"></BI>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import BI from "../../components/BI";

import { Stack, StackItem } from "vue-stack-grid";

import sessionHelper from "../../helpers/sessionHelper";

export default {
  name: "Reports",
  data() {
    return { grid: null };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "آمار و نمودار ها" }]);
  },
  methods: {},
  components: {
    BI,
  },
  methods: {},
};
</script>